import { useContext, useEffect, useState } from 'react';
import Inputs from './components/Inputs';
import useHttp from '../../../hooks/use-http';
import { urls } from './urls/urls';
import GridProvider from './components/GridProvider';
import MyButton from '../../UI/myButton/MyButton';
import toast from 'react-hot-toast';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import DragAndDrop from '../../UI/DragAndDrop';
import { useTranslation } from 'react-i18next';
import { formatDateToDB } from '../../../../utils/FormatDate';
import { convertBase64ToFile } from '../../../../utils/convertBase64ToFile';
import { downloadFile } from '../../../../utils/downloadFile';

const initialValues = {
  id: 0,
  idKupca: null,
  naziv: '',
  sifra: '',
  idKorProm: 0,
};

const KlijentiAlati = ({ idKlijenta }) => {
  const { t, i18n } = useTranslation();
  const { sendRequest, data, isLoading } = useHttp('');
  const [formData, setFormData] = useState(initialValues);
  const { getData } = useHttp('');
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openDialogFile, setOpenDialogFile] = useState(false);
  const [attachmentData, setAttachmentData] = useState([]);
  const [openDeleteFileDialog, setOpenDeleteFileDialog] = useState(false);
  const [fileForDelete, setFileForDelete] = useState();
  const [rowId, setRowId] = useState(null);

  const fetchData = () => {
    const config = {
      method: 'POST',
      url: urls.GET_ALATI,
      data: { id: idKlijenta },
    };
    sendRequest(config);
  };

  useEffect(() => {
    fetchData();
  }, []);
  const handleOpenDeleteDialog = (id) => {
    setFormData({ ...formData, id: id });
    setOpenDeleteDialog(true);
  };
  const handleEditData = (item) => {
    setFormData({
      id: item.id,
      idKupca: item.idKupca,
      naziv: item.naziv,
      sifra: item.sifra,
    });
  };
  const handleNoviUnos = () => {
    setFormData(initialValues);
  };
  const handleSaveData = async () => {
    const url = formData.id === 0 ? urls.INSERT_ALAT : urls.UPDATE_ALAT;
    const config = {
      url,
      method: 'POST',
      data: {
        ...formData,
        idKupca: idKlijenta,
        idKorProm: +localStorage.idKorisnika,
      },
    };
    const response = await getData(config);

    if (response.id > 0) {
      toast.success(
        formData.id === 0 ? 'Uspešan unos alata' : 'Uspešna izmena alata',
      );
      fetchData();
      setFormData(initialValues);
    } else {
      toast.error('Greška pri čuvanju podataka');
    }
  };
  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_ALAT,
      data: { id: formData.id },
    };
    const result = await getData(config);

    if (result > 0) {
      fetchData();
      toast.success('Uspešano obrisan podatak');
      setOpenDeleteDialog(false);
      setFormData(initialValues);
      return;
    }
    toast.error('Greška prilikom brisanja podatka');
  };
  const handleDownloadFile = async (item) => {
    const config = {
      method: 'POST',
      url: urls.DOWNLOAD_DOKUMENT,
      data: { id: item.id },
    };
    const result = await getData(config);
    if (result) {
      const file = convertBase64ToFile(result, item.name, item.type);
      downloadFile(file);
    }
  };
  const handleGetFile = async (id) => {
    const config = {
      method: 'POST',
      url: urls.GET_DOKUMENTA,
      data: { idObjekta: id, objekat: 'kalat', metadata: i18n.language },
    };
    const result = await getData(config);
    setAttachmentData(result);
  };
  const handleFiles = (files) => {
    console.log(files);
    const fileList = attachmentData.concat(files);
    console.log(fileList);
    setAttachmentData(fileList);
  };
  const handleRemoveFile = (file) => {
    setFileForDelete(file);
    setOpenDeleteFileDialog(true);
  };
  const handleDeleteFile = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_DOKUMENT,
      data: { id: fileForDelete.id ? fileForDelete.id : 0 },
    };
    const result = await getData(config);
    if (
      result.response &&
      result.response.data.includes('nije pronađen/obrisan')
    ) {
      const newFileList = attachmentData.filter((item) => {
        return item.name !== fileForDelete.name;
      });

      setOpenDeleteFileDialog(false);
      setAttachmentData(newFileList);
      return;
    }
    if (result) {
      const newFileList = attachmentData.filter((item) => {
        return item.id !== fileForDelete.id;
      });
      setOpenDeleteFileDialog(false);
      setAttachmentData(newFileList);
    }
  };
  const handleOpenDialogFile = (row) => {
    setOpenDialogFile(true);
    setRowId(row.id);
    handleGetFile(row.id);
  };
  const handleSaveDocuments = async () => {
    const fd = new FormData();
    fd.append('IdVrsteDokOpste', 0);
    fd.append('objekat', 'kalat');
    fd.append('IdObjekta', rowId);
    fd.append('NazivFajla', null);
    fd.append('IdJezika', 0);
    fd.append('Kategorija', null);
    fd.append('Datum', formatDateToDB(new Date()));
    fd.append('IdKorProm', +localStorage.idKorisnika);
    for (let i = 0; i < attachmentData.length; i += 1) {
      fd.append('Dokumenti', attachmentData[i]);
    }
    const config = {
      method: 'POST',
      url: urls.INSERT_DOKUMENTA,
      data: fd,
    };
    const result = await getData(config);

    console.log(result);
    if (result) {
      toast.success('Uspešno sačuvani dokumenti.');
      handleGetFile(rowId);
    }
  };
  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Inputs formData={formData} setFormData={setFormData} />
        {idKlijenta && (
          <div>
            <MyButton label="Sačuvaj alat" onClick={handleSaveData} />
            <MyButton label="Novi alat" onClick={handleNoviUnos} />
          </div>
        )}
      </div>
      <GridProvider
        data={data}
        handleOpenDialog={handleOpenDeleteDialog}
        getEditData={handleEditData}
        isLoading={isLoading}
        handleOpenDialogFile={handleOpenDialogFile}
      />
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title="Obriši"
        text="Da li ste sigurni da želite da obrišete alat?"
        handleClose={() => setOpenDeleteDialog(false)}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
      <MuiDialog
        maxWidth="sm"
        open={openDeleteFileDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={() => setOpenDeleteFileDialog(false)}
        handleConfirm={handleDeleteFile}
        deniedText="ZATVORI"
      />
      <MuiDialog
        maxWidth="sm"
        open={openDialogFile}
        title="Dodavanje dokumenata"
        content={
          <DragAndDrop
            handleFiles={handleFiles}
            maxFiles={100}
            addedFiles={attachmentData}
            handleRemoveFile={handleRemoveFile}
            customDownload={handleDownloadFile}
            enableCustomDownload
          />
        }
        handleClose={() => setOpenDialogFile(false)}
        handleConfirm={handleSaveDocuments}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default KlijentiAlati;
